import browser from "bowser";
var PREFIX = browser.webkit || browser.blink ? "-webkit-" : browser.gecko ? "-moz-" : "";
export default {
  DEFAULTS: {},
  CURSOR: {
    GRABBING: "".concat(PREFIX, "grabbing"),
    GRAB: "".concat(PREFIX, "grab"),
    POINTER: "pointer"
  }
};